import { createI18n } from 'vue-i18n'
import tr from './locales/tr.json'
import en from './locales/en.json'
import { local, STORAGE_KEYS } from './utils/storage'

function detectDefaultLocale () {
  const saved = local.get(STORAGE_KEYS.LOCALE)
  if (saved) return saved
  return 'tr'
}

export const supportedLocales = ['tr', 'en']

export const i18n = createI18n({
  legacy: false,
  allowComposition: true,
  globalInjection: true,
  locale: detectDefaultLocale(),
  fallbackLocale: 'tr',
  messages: {
    tr,
    en
  }
})

export function setLocale (locale) {
  if (!supportedLocales.includes(locale)) return
  i18n.global.locale.value = locale
  local.set(STORAGE_KEYS.LOCALE, locale)
}

export default i18n
